import { useFeature } from "src/core/common/hooks/useFeature";
import FEATURES from "src/core/constants/features";

export const useIsCostCenterFeatureEnabled = () =>
  useFeature(FEATURES.COST_CENTERS_ACTIVATED);
